import { DataBean } from "../DataBean";

export class CargoManifestType extends DataBean {

    public async getCargoManifestTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCargoManifestTypeConstants_Number", [args]);
    }

}